import { createSelector } from "reselect";
import { getLoads } from "./root";

export const selectLoadsForAgGrid = createSelector([getLoads], loads =>
  Object.values(loads),
);
